import { useBranding } from '../../contexts/SiteContext';

interface AuthLayoutProps {
  title: string;
  subtitle?: string;
  children: React.ReactNode;
}

export function AuthLayout({ title, subtitle, children }: AuthLayoutProps) {
  const branding = useBranding();

  return (
    <div className="min-h-screen bg-zinc-50 flex flex-col justify-center py-12 px-4 sm:px-6 lg:px-8">
      <div className="sm:mx-auto sm:w-full sm:max-w-md">
        <div className="flex justify-center mb-6">
          {branding.logoUrl ? (
            <img
              src={branding.logoUrl}
              alt={branding.name}
              className="h-12 w-auto object-contain"
            />
          ) : (
            <div
              className="w-12 h-12 rounded-2xl flex items-center justify-center text-white text-xl font-bold shadow-sm"
              style={{ backgroundColor: 'var(--color-primary, #4F46E5)' }}
            >
              {branding.name.charAt(0).toUpperCase()}
            </div>
          )}
        </div>

        <p className="text-center text-xs font-semibold tracking-widest uppercase text-zinc-400 mb-2">
          {branding.name}
        </p>

        <h2 className="text-center text-2xl font-bold text-zinc-900">{title}</h2>
        {subtitle && (
          <p className="mt-1.5 text-center text-sm text-zinc-500">{subtitle}</p>
        )}
      </div>

      <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
        <div className="bg-white py-8 px-6 shadow-sm rounded-2xl border border-zinc-100">
          {children}
        </div>
      </div>
    </div>
  );
}
